<template>
  <div>
    <div class="project-info">
      <div class="info-item">项目名称：{{projectData.projectName}}</div>
      <div class="info-item">开标日期：{{ projectData.clMeetingRoom.beginTime | filterTime }}</div>
      <div class="info-item">项目编号：{{projectData.projectFull}}</div>
      <div class="info-item">中标公告日期：{{projectData.winTime | filterTime}}</div>
    </div>
    <Table :data="depositRefundData" :columns="columns"></Table>
    <div v-for="bidder in bidders" style="border-top:1px solid #ddd;margin-top:20px;">
      <div style="padding:5px 15px;">
        <span>中标单位：{{bidder.abpEnroll.companyName}}</span>
        <span style="margin-left:80px;">中标金额：{{bidder.winAmount}}</span>
        <span style="margin-left:80px;">中标包组：{{bidder.groupNumber}}</span>
        <span v-if="bidder.clGroupDb&&bidder.clGroupDb.isBuyer" style="color:#19be6b;">（采购人付款）</span>
      </div>
      <div style="padding:5px 15px;" v-if="bidder.serviceCharge&&bidder.serviceCharge.length>0">
        <template v-for="serviceCharge in bidder.serviceCharge">
          <div>
            <span>服务费收取时间：{{serviceCharge.ordersDto.payTime | filterTime}}</span>
            <span style="margin-left:65px;">服务费收取金额：{{serviceCharge.ordersDto.orderAmountTotal}}</span>
            <span style="margin-left:65px;">合同存档日期：{{serviceCharge.pactTime | filterTime}}</span>
          </div>
        </template>
      </div>
    </div>
    <div style="margin-top:16px;" v-if="bidServiceCharge.length>0">
      <span>采购人付款服务费<span style="color:#ff9900;"></span></span>
      <div v-for="serviceCharge in bidServiceCharge" style="border-top:1px solid #ddd;margin-bottom:20px;padding:5px 15px;">
        <div>
          <span>公司名称：{{serviceCharge.companyName}}</span>
          <span style="margin-left:65px;">信用代码：{{serviceCharge.companyNo}}</span>
        </div>
        <span>服务费收取时间：{{serviceCharge.ordersDto.payTime | filterTime}}</span>
        <span style="margin-left:65px;">服务费收取金额：{{serviceCharge.ordersDto.orderAmountTotal}}</span>
        <span style="margin-left:65px;">合同存档日期：{{serviceCharge.pactTime | filterTime}}</span>
      </div>
    </div>
    <div style="text-align:right;margin-top:5px;">
      <Button @click="printView" type="primary">打印预览</Button>
    </div>
    <Modal v-model="printVisible" title="退投标保证金申请" :transfer="false" width="800" class-name="print-modal">
      <depositPrint :depositRefundData="depositRefundData" :bidServiceCharge="bidServiceCharge" :flowHistoryData="flowHistoryData" :projectData="projectData" :bidders="bidders"></depositPrint>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { fileUtil } from '@/lib/abpfile'
import { formatDate } from '@/lib/tool'
import x2js from "x2js"
import DepositPrint from './depositPrint'
import {getFlowHistory} from '@/lib/flow'

export default {
  name: 'depositRefundDetail',
  props: {
    workFlowId: {
      type: String
    }
  },
  components: {
    DepositPrint
  },
  data() {
    return {
      depositRefundData: [],
      columns: [
        {
          title: '汇款单位',
          render: (h, params) => {
            return h('div', params.row.orders.abpOrdersExp.bankName)
          }
        },
        {
          title: '报名供应商',
          render: (h, params) => {
            return h('div', params.row.orders.ghfCompanyName)
          }
        },
        {
          title: '包组',
          width: 65,
          render: (h, params) => {
            return h('div', params.row.orders.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '中标',
          width: 65,
          render: (h, params) => {
            // const content = JSON.parse(params.row.content)
            const x2Json = new x2js()
            const xmlJSON = x2Json.xml2js(params.row.content)
            return h('div', xmlJSON.root.isBidding)
          }
        },
        {
          title: '金额',
          width: 80,
          render: (h, params) => {
            return h('div', params.row.orders.orderAmountTotal)
          }
        },
        // {
        //   title: '文件上传',
        //   width: 85,
        //   render: (h, params) => {
        //     // 最大文件大小
        //     this.uploadMargin = params.row
        //     const maxSize = 100
        //     return (
        //       <Upload data={this.uploadFileInit.extradata} action={this.uploadFileInit.action} before-upload={this.handleBeforeUpload} show-upload-list={false}>
        //         <Button type="primary" size="small">上传</Button>
        //       </Upload>
        //     )
        //   }
        // },
        {
          title: '文件名',
          key: 'fileName',
          width: 120,
          render: (h, params) => {
            return h('div', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on: {
                click: async () => {
                  let fileUrl = await fileUtil.downLoadBlob(params.row.fileId)
                  
                  // 文件预览功能
                  let fileType = params.row.fileName.split('.')
                  fileType = fileType[fileType.length - 1]
                  // 图片预览
                  let imgTypes = ['png', 'jpg', 'jpeg']
                  if (imgTypes.indexOf(fileType) !== -1) {
                    this.$showImage(fileUrl)
                    return
                  }
                  // pdf预览
                  let pdfTypes = ['pdf']
                  if (pdfTypes.indexOf(fileType) !== -1) {
                    window.open('pdf/web/viewer.html?file=' + fileUrl)
                    return
                  }
                  // window.open(fileUrl)
                  const link = document.createElement('a')
                  link.href = fileUrl
                  link.download = params.row.fileName
                  link.click()
                }
              }
            }, params.row.fileName)
          }
        },
        {
          title: '备注',
          key: 'comment'
        }
      ],
      printVisible: false,
      flowHistoryData: [],
      bidders: [], // 中标人
      serviceCharges: [], //已收取服务费
      bidServiceCharge: []
    }
  },
  computed: {
    projectData() {
      this.bidders = []
      this.bidServiceCharge = []
      if (this.depositRefundData.length > 0 && this.depositRefundData[0].project) {
        // 获取中标单位和服务费
        this.resortBidService(this.depositRefundData[0].project.id)
        if (!this.depositRefundData[0].project.clMeetingRoom) {
          this.depositRefundData[0].project.clMeetingRoom = {}
        }
        return this.depositRefundData[0].project
      }
      return {clMeetingRoom: {}}
    },
    userPhone() {
      return this.$store.state.session.user.phoneNumber
    }
  },
  methods: {
    // 获取中标单位
    async getBiddingCompany(projectId = '00') {
      let rep = await ajax.get(requestUrls.enroll.GetEnrollExt, {
        params: {
          pid: projectId
        }
      })
      this.bidders = []
      if (rep.data.success) {
        rep.data.result.items.forEach(item => {
          // 中标筛选
          if (item.status) {
            this.bidders.push(item)
          }
        })
      }
    },
    // 获取已收取服务费
    async getReceiveFee(projectId = '00') {
      let rep = await ajax.get(requestUrls.AbpServiceCharge.getPaged, {
        params: {
          filter: `s.projectId == "${projectId}"`,
          maxResultCount: 100,
          skipCount: 0,
        }
      })
      this.serviceCharges = []
      if (rep.data.success) {
        this.serviceCharges = rep.data.result.items
      }
    },
    // 中标单位及服务费归类
    async resortBidService(projectId = '00') {
      await this.getBiddingCompany(projectId)
      await this.getReceiveFee(projectId)
      this.serviceCharges.forEach(serviceCharge => {
        if (serviceCharge.status === '1' && serviceCharge.isBuyer) {
          this.bidServiceCharge.push(serviceCharge)
        }
      })

      this.bidders.forEach(bidder => {
        // 服务费
        for (let i = 0; i < this.serviceCharges.length; i++) {
          const serviceCharge = this.serviceCharges[i]
          if (serviceCharge.status === '1' && serviceCharge.groupId === bidder.groupId && serviceCharge.companyName === bidder.abpEnroll.companyName) {
            let services = []
            if (bidder.serviceCharge && bidder.serviceCharge.length > 0) {
              services = services.concat(bidder.serviceCharge, [serviceCharge])
              // services.push(serviceCharge)
            } else {
              services.push(serviceCharge)
            }
            this.$set(bidder, 'serviceCharge', services)
          }
        }
        // 包组
        for (let j = 0; j < this.depositRefundData.length; j++) {
          const refundData = this.depositRefundData[j]
          if (refundData.orders && refundData.orders.abpOrdersExp.groupId === bidder.groupId && bidder.abpEnroll.companyName === refundData.orders.ghfCompanyName) {
            bidder.clGroupDb = refundData.orders.abpOrdersExp.clGroupDb
            break
          }
        }
      })
    },
    async getFlowLog() {
      let rep = await ajax.get(requestUrls.AbpFlowLog.GetPaged, {
        params: {
          filter: `flowType=="退保证金" and workflowId=="${this.workFlowId}"`,
          skipCount: 0,
          maxResultCount: 200,
        }
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    async printView() {
      // 获取流程信息
      this.flowHistoryData = await getFlowHistory(this.userPhone, this.workFlowId)
      this.printVisible = true
      // const url = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%2F%5B9000%5D%5B6295%5D%5B6807%5D%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%5B7533%5D%5B8bf7%5D%5B8868%5D.cpt&WorkFlowId=${this.workFlowId}`
      // window.open(url)
    }
  },
  watch: {
    async workFlowId(val) {
      if (val) {
        this.depositRefundData = await this.getFlowLog()
      }
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return '无挂网日期'
      }
      return formatDate(val).split(' ')[0]
    }
  }
}
</script>

<style lang="less" scoped>
.project-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
  .info-item {
    padding: 0 15px;
    font-weight: 600;
    font-size: 14px;
    min-width: 400px;
  }
}
/deep/.print-modal {
  .ivu-modal {
    top: 30px;
  }
  .ivu-modal-close {
    display: none;
  }
}
</style>
